// Mirrors the `client_user_type` DB table; source of truth for user-type indices
export const UserType = {
  Index: {
    SalesRep: 100,
    Manager: 101,
    LWS_ADMIN: 102,
    LWS_DEALER: 103,
    LWS_SCHOOL: 104,
    LWS_SUPPORT: 105
  } as const,

  Name: {
    SalesRep: "Sales_Rep",
    Manager: "Manager",
    LWS_ADMIN: "LWS_ADMIN",
    LWS_DEALER: "LWS_DEALER",
    LWS_SCHOOL: "LWS_SCHOOL",
    LWS_SUPPORT: "LWS_SUPPORT",
  } as const,

  // Most client users never pass through the chooser (a Manager does — see
  // clientUserPicksContext), so they often have no selectedUserType — only
  // user.client_type_name. Lets callers resolve one from the other without
  // inlining the indices.
  IndexByName: {
    Sales_Rep: 100,
    Manager: 101,
    LWS_ADMIN: 102,
    LWS_DEALER: 103,
    LWS_SCHOOL: 104,
    LWS_SUPPORT: 105,
  } as const,
} as const;

export type UserTypeIndex = typeof UserType.Index[keyof typeof UserType.Index];
export type UserTypeName = typeof UserType.Name[keyof typeof UserType.Name];
